import { useField } from '../hooks';
import { offer } from '../paths';
export var useOffer = function () { return useField(offer); };
